export function formatCPF(cpf: string | number): string {
  // garante que é string
  const digits = String(cpf);

  // valida se tem 11 números
  if (!/^\d{11}$/.test(digits)) {
    throw new Error("CPF inválido: deve conter 11 dígitos.");
  }

  // aplica a máscara
  return digits.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    "$1.$2.$3-$4"
  );
}